<template>
  <v-container fluid>
    <v-row class="common-card-row">
      <v-col class="common-card-col">
        <v-row no-gutters>
          <v-col cols="12" sm="4" class="text-h6 pt-1">
            <span class="titleLight--text">{{ $t("views.Analytics.pageTitle") }}</span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="4">
            <InputSelectVT
              height="32"
              :items="page_content.overview_select"
              @value_changes="get_updated_stats($event)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="common-card-row">
      <v-col cols="12" md="8" class="pa-0 pb-3 pb-md-0">
        <v-col class="common-card-col" cols="12">
          <div class="d-flex justify-space-between">
            <div class="text-h6 titleLight--text pt-3">
              {{ $t("views.Analytics.charts.totalPower.title") }}
            </div>
            <div class="pa-1">
              <v-chip class="ma-2" color="primary">
                <b>{{ $t("common.words.total") }} : </b>
                {{ $numberWithCommas(Math.round(total_power)) }}
                {{ $t("common.measure.kVA") }}
                <v-icon small right> mdi-flash </v-icon>
              </v-chip>
            </div>
          </div>
          <AreaChartVT
            :chartData="overview_data_formatted"
            :xlabel="areaChartXlabel"
            :ylabel="areaChartYlabel"
            lineWidth="0.6"
            pointSize="0.6"
            dataOpacity="1"
          />
        </v-col>
      </v-col>
      <v-col cols="12" md="4" class="pa-0 pl-md-3">
        <v-col class="common-card-col" cols="12">
          <div class="text-h6 titleLight--text px-4 pt-3">
            {{ $t("views.Analytics.charts.issues.title") }}
          </div>
          <ColumnChartVT
            v-if="issues_chart"
            :xlabel="columnChartXlabel"
            :ylabel="columnChartYlabel"
            :chartData="issues_chart"
            @on-click="apply_graph_filter($event)"
          />
        </v-col>
      </v-col>
      <!-- <v-col cols="6">
        <DiversityChart :data="diversity_data" :chartData="page_content.diversity_chart_data"></DiversityChart>
      </v-col>
      <v-col cols="6">
        <DiversityChart1 :data="diversity_data" :chartData="page_content.diversity_chart_data1"></DiversityChart1>
      </v-col> -->
    </v-row>
    <v-row class="common-card-row">
      <v-col cols="12" md="6" class="pa-0 pb-3">
        <v-col class="common-card-col" cols="12">
          <v-card flat>
            <v-card-title class="titleLight--text text-h6">
              {{ $t("views.Analytics.tables.devices.title") }}
            </v-card-title>
            <v-card-text class="pa-0">
              <DataTableVT
                :headers="page_content.devices_table"
                :items_list="device_data"
                sort_by="MaxUtilisation"
                item_key="DeviceID"
                :loading="is_loading"
                @action="redirect_user($event)"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-col>
      <v-col cols="12" md="6" class="pl-0 pl-md-3 pr-0 pt-0">
        <v-col class="common-card-col" cols="12" v-if="map_data">
          <MapsVT
            v-if="map_data"
            :options="page_content.maps_config"
            :legends="$config.map_powercoil_legends"
            :items="map_data"
            height="80vh"
            :clusterMarkers="clusterMarkers"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ message }}</v-snackbar>
  </v-container>
</template>

<script>
import MapsVT from "../components/MapsVT";
import DataTableVT from "../components/DataTableVT";
import InputSelectVT from "../components/InputSelectVT";
import ColumnChartVT from "../components/ColumnChartVT";
import AreaChartVT from "../components/AreaChartVT";
import { axios_get } from "../services/vt_service";
import { trafo } from "../services/powerdata";
import { content } from "../../config/analytics.js";

export default {
  name: "Analytics",
  components: {
    MapsVT,
    DataTableVT,
    InputSelectVT,
    ColumnChartVT,
    AreaChartVT,
  },
  data: function () {
    return {
      areaChartXlabel: this.$t("views.Analytics.charts.totalPower.yLabel"),
      areaChartYlabel: this.$t("views.Analytics.charts.totalPower.xLabel"),
      columnChartXlabel: this.$t("views.Analytics.charts.issues.xLabel"),
      columnChartYlabel: this.$t("views.Analytics.charts.issues.yLabel"),
      is_loading: false,
      snackbar: false,
      network_error: false,
      hide_legends: true,
      devices: [],
      search_term: "",
      error_message: "",
      diversity_data: null,
      diversity_data1: null,
      total_assets: 0,
      total_assets_known: 0,
      total_assets_unknown: 0,
      perc_assets_known: 0,
      perc_assets_unknown: 0,
      value_missing_assets: 0,
      deviceId: null,
      dialog: false,
      overview_data: null,
      duration: 1,
      total_power: 0,
      message: "",
      clusterMarkers: true,
      chartOptions: {
        slices: {
          0: { color: "#DB4366" },
          1: { color: "#3B918B" },
        },
        pieHole: 0.4,
      },
      chartOptions2: {
        slices: {
          0: { color: "#f8961e" },
          1: { color: "#B0BEC5" },
        },
        pieHole: 0.4,
      },
      current_list: "all",
      location_data: null,
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    this.get_device_list();
    this.get_stats();
    // this.get_diversity_data();
    // this.$store.commit("update_page_title", "Analytics");
  },
  filters: {
    timeSince(date_string) {
      var date = new Date(date_string);
      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = Math.floor(seconds / 31536000);

      if (interval > 1) {
        return interval + this.$t("common.times.time.yearsAgo");
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + this.$t("common.times.time.monthsAgo");
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + this.$t("common.times.time.daysAgo");
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + this.$t("common.times.time.hoursAgo");
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return interval + this.$t("common.times.time.minutesAgo");
      }
      return Math.floor(seconds) + this.$t("common.times.time.secondsAgo");
    },
  },
  methods: {
    redirect_user(ev) {
      let path = `/asset/${ev[1].DeviceID}`;
      let routeData = this.$router.resolve({
        path: path,
        query: { type: "add" },
      });
      window.open(routeData.href, "_blank");
    },
    get_updated_stats(val) {
      this.duration = val;
      this.get_stats();
    },
    apply_graph_filter(val) {
      let issues = Object.keys(this.$config.issues);
      let issueLabel = "";
      issues.forEach((key) => {
        if (this.$config.issues[key].label == val) issueLabel = key;
      });
      val =
        !val || (val && issueLabel)
          ? issueLabel
          : ["HasTemperatureOutsideRange", "HasTemperatureOverLimit", "HasTemperatureSenseError"];
      this.message = val
        ? this.$t("common.messages.filter.filterApplied")
        : this.$t("common.messages.filter.filterRemoved");
      this.snackbar = true;
      this.current_list = val ? val : "all";
    },
    open_details(deviceId) {
      this.deviceId = deviceId;
      this.dialog = true;
    },
    sort(s) {
      if (s === this.current_sort) {
        this.current_sort_dir = this.current_sort_dir === "asc" ? "desc" : "asc";
      }
      this.current_sort = s;
    },
    async get_device_list() {
      this.is_loading = true;
      this.network_error = false;
      const response = await axios_get(trafo.get_assets_data, { num_days: 1 }, { only_installed: 1 });
      this.devices = response.map((elem) => {
        let issues = Object.keys(this.$config.issues);
        let hasIssue = false;
        let hasCapacityOverLimit = false;
        let hasCapacityUnderLimit = false;

        issues.forEach((key) => {
          if (elem[key]) {
            hasIssue = true;
          }
        });
        if (!elem["MaxUtilisation"] || (elem["MaxUtilisation"] && elem["MaxUtilisation"] < 15)) {
          hasCapacityUnderLimit = true;
        } else if (elem["MaxUtilisation"] && elem["MaxUtilisation"] > 85) {
          hasCapacityOverLimit = true;
        }
        elem.HasIssue = hasIssue;
        elem.HasCapacityOverLimit = hasCapacityOverLimit;
        elem.HasCapacityUnderLimit = hasCapacityUnderLimit;
        return elem;
      });
      this.is_loading = false;
    },
    async get_stats() {
      this.network_error = false;
      const response = await axios_get(trafo.get_chart_stats, { duration: this.duration });
      this.overview_data = response;
      this.total_power = 0;
      response.map((elem) => {
        this.total_power = this.total_power + elem.TotalMax;
      });
    },
    async get_diversity_data() {
      this.network_error = false;
      let response = await axios_get(trafo.get_diversity_data);
      let data = {};
      response.map((elem) => {
        data[elem.DeviceID] = !data[elem.DeviceID]
          ? {
              id: elem.DeviceID,
              label: elem.DeviceID,
              avg: elem.AVG_NormalisedPower,
              values: [],
            }
          : data[elem.DeviceID];

        data[elem.DeviceID].values[elem.HourOfDay] = {
          key: elem.HourOfDay,
          avg_np: elem.AVG_NormalisedPower,
          np: elem.NormalisedPower,
          value: elem.NormalisedPower,
        };
      });
      this.diversity_data = Object.keys(data)
        .map((e) => data[e])
        .sort(function (a, b) {
          return a.avg - b.avg;
        });
    },
  },
  computed: {
    overview_data_formatted: function () {
      let temp = [
        [
          "Timestamp",
          this.$t("views.Analytics.charts.totalPower.bottomLabelMaxCapacity"),
          this.$t("views.Analytics.charts.totalPower.bottomLabelTotalCapacity"),
        ],
      ];
      let current_year = new Date().getFullYear();
      this.overview_data &&
        this.overview_data.map((elem) => {
          let date = new Date(current_year, 0);
          date = new Date(date.setDate(elem.DayOfYear));
          date.setHours(elem.HourOfDay);
          temp.push([date, elem.TotalCapacity, elem.TotalMax]);
        });
      return this.overview_data ? temp : null;
    },
    issues_chart: function () {
      let temp = {
        HasCapacityUnderLimit: 0,
        HasCapacityOverLimit: 0,
        HasImbalance: 0,
        HasCurrentOverLimit: 0,
        HasLowBattery: 0,
        HasNoPower: 0,
        // HasTemperatureOutsideRange: 0,
        // HasTemperatureOverLimit: 0,
        // HasTemperatureSenseError: 0,
      };
      let tempIssue = 0;
      // let hasCapacityProblem = 0;
      let data = [
        [
          this.$t("views.Analytics.charts.issues.xLabel"), //"Issue",
          this.$t("views.Analytics.charts.issues.yLabel"),
          { role: "annotation" },
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
      ];
      this.devices.map((elem) => {
        Object.keys(temp).forEach((key) => {
          if (elem[key]) {
            temp[key] = temp[key] + 1;
          }
        });
        if (elem["HasTemperatureOutsideRange"] || elem["HasTemperatureOverLimit"] || elem["HasTemperatureSenseError"]) {
          tempIssue = tempIssue + 1;
        }
      });
      Object.keys(temp).forEach((key) => {
        if (temp[key] != 0)
          data.push([this.$config.issues[key].label, temp[key], temp[key], this.$config.issues[key].tooltip]);
      });
      data.push([
        this.$t("common.messages.warnings.temperatureError"),
        tempIssue,
        tempIssue,
        this.$t("common.messages.warnings.temperatureInvestigationWarning"),
      ]);
      return data.length > 1 ? data : null;
    },
    map_data: function () {
      return this.device_data
        ? this.device_data.filter((elem) => {
            return elem.CurrentLat && elem.CurrentLng ? true : false;
          })
        : null;
    },
    device_data: function () {
      return this.devices
        ? this.devices.filter((elem) => {
            if (
              this.current_list &&
              typeof this.current_list == "string" &&
              this.current_list.toLowerCase().trim() != "all"
            ) {
              return elem[this.current_list.trim()];
            }
            if (typeof this.current_list == "object") {
              return (
                elem["HasTemperatureOutsideRange"] ||
                elem["HasTemperatureOverLimit"] ||
                elem["HasTemperatureSenseError"]
              );
            }
            return true;
          })
        : null;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .export-div {
  top: 35px;
}

::v-deep .right-border {
  border-right: 1px solid var(--v-border-base);
}
</style>
